module.exports = __webpack_public_path__ + "static/media/AVISOIMPORTANTEdiciembre2023.65c66754.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/AVISOIMPORTANTEdiciembre2023.pdf
// module id = 966
// module chunks = 0